import { render, staticRenderFns } from "./DdlCityComponent.vue?vue&type=template&id=06bce5c7"
import script from "./DdlCityComponent.vue?vue&type=script&lang=js"
export * from "./DdlCityComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports